import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PendapatanProdukContent from "./PendapatanProdukContent";

const SalesMembershipsPage = () => (
  <PendapatanProdukContent
    type="membership"
    title={translate("analyticsPage.membership.report_pendapatan_produk")}
    backTo={PATHS.ANALYTICS}
  />
);

export default SalesMembershipsPage;
